import { useNProgress } from './useNProgress';
export const NProgress = ({ children, ...restProps }) => {
    const renderProps = useNProgress(restProps);
    return children(renderProps);
};
